<template>
  <Content>
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
      >
        <template #controls="{ row }">
          <router-link :to="`edit/${row.state}/`">
            <el-button icon="el-icon-edit" size="mini">Редактировать</el-button>
          </router-link>
        </template>
      </Table>
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getRequestsSchemas } from "@/api/approval";

const columnsOptions = {
  items: "states",
  controls: true,
};

const columns = [
  {
    prop: "state",
    label: "Статус заявки",
    type: "enum",
    alias: "state_type",
  },
  {
    prop: "roles",
    label: "Роли",
    type: "enum",
    alias: "role_type",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        async fetchData(params) {
          const data = await getRequestsSchemas(params);
          return data.states;
        },
      },
    };
  },
};
</script>
